<template>
  <div class="product-details-content-register-module-customization">
    <tab-cover :form="form" :errors="errors" />

    <h5 class="text-semibold mt-7 pt-4 mb-4">Cartaz vertical</h5>
    <div class="row">
      <div class="col-lg-4">
        <snow-input-file
          v-model="form.picture"
          isImage
          id="imagem-vertical"
          backgroundColor="bg-1"
          title="Cartaz vertical"
          dimensions="440x632"
        />
      </div>
      <div class="col-lg-6 d-lg-flex d-none">
        <img src="@/assets/images/member-area/tab-placeholder-vertical.svg" />
      </div>
    </div>
  </div>
</template>
<script>
import TabCover from "@/components/product/details/content/customize/TabCover.vue";

export default {
  components: {
    TabCover
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
